module.exports = __webpack_public_path__ + "static/tasks@2x.5ad94bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/connect/tasks@2x.png
// module id = 849
// module chunks = 68530290604204